// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-e6591b9a],\n.fade-leave-active[data-v-e6591b9a] {\n  transition: all 0.5s ease;\n}\n.fade-enter-from[data-v-e6591b9a],\n.fade-leave-to[data-v-e6591b9a] {\n  transform: translateY(-20%);\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
